export const getRegisterSteps = (activeRegisterStep: number) => [
  {
    textKey: 'registrationProgressProgressPersonal',
    isActive: activeRegisterStep === 1,
    isCompleted: activeRegisterStep > 1
  },
  {
    textKey: 'registrationProgressProgressCourses',
    isActive: activeRegisterStep === 2,
    isCompleted: activeRegisterStep > 2
  },
  {
    textKey: 'registrationProgressProgressApproved',
    isActive: activeRegisterStep === 3,
    isCompleted: activeRegisterStep > 3
  },
  {
    textKey: 'registrationProgressProgressPayment',
    isActive: activeRegisterStep === 4,
    isCompleted: activeRegisterStep > 4
  },
  {
    textKey: 'registrationProgressProgressAllDone',
    isActive: activeRegisterStep === 5,
    isCompleted: activeRegisterStep === 5
  }
]
